module.exports = __webpack_public_path__ + "static/media/splash_goblins.77a582e5.png";